import { AppMode, BetbyBonusBehavior, CatalogFilter, EndpointType, Theme } from '../types.js';
// SEO configuration for Fomo brand
const themeSetting = {
    theme: Theme.Turboslots,
    rankConfig: { sublevelFormat: 'numeric' },
    betbyEnabled: true,
    betbyBonusBehavior: BetbyBonusBehavior.NoBonusMoney,
    betbyThemeName: 'turboslot',
    sportmodity: {
        enabled: true,
        style: 'dark',
        isUsLayout: false
    },
    brand: 'turboslot.com',
    brandTitle: 'TurboSlot',
    notFoundImage: 'not-found.svg',
    canonicalUrl: 'https://turboslot.com',
    cdnBase: 'https://turbo-cdn.gmcdn.org',
    cdnBaseFallbacks: ['https://turbo.gmcdn.org'],
    cdnTiles: 'https://turbo-tiles.gmcdn.org',
    cdnBanners: 'https://images.fomo.io/',
    cubePayEnabled: true,
    discordLink: '',
    googleAnalytics: '',
    googleClientId: undefined, //'1030216308308-9ceh2uirt0ltfdb0duunbmg83kp41s9a.apps.googleusercontent.com',
    googleTagManager: undefined,
    languageDefault: 'tr',
    languages: ['tr', 'en'],
    topProvidersSlugs: ['turbo-originals'],
    languagesTiles: ['tr', 'en'],
    languagesAutoAccept: [],
    megajackpotFeed: {
        operator: 'TURBOBET',
        hash: '0fc399c791bdd3d4d41ff523848e0c84a981a5bb7ef595706797816f14551aef'
    },
    liveChatLicenseId: '12771834',
    supportChatMode: 'direct',
    supportEmail: 'info@turboslot.com',
    telegramLink: 'https://t.me/turboslotsosyal',
    xLink: undefined, //'https://x.com/',
    noIndex: true,
    gameSetLimit: 60,
    themePath: 'fomoio',
    verbiageLabel: 'fomoio',
    callRequestForm: {
        id: 'CoinbarGroupForms',
        src: 'https://turbocall1.com/call/call.php',
        origin: 'https://turbocall1.com'
    },
    paymentIssueForms: {
        deposit: {
            id: 'turboyatkt',
            src: 'https://turbogamers.club/formlar/yatirimkt.php',
            origin: 'https://turbogamers.club'
        },
        withdrawal: {
            id: 'turbocekkt',
            src: 'https://turbogamers.club/formlar/cekimkt.php',
            origin: 'https://turbogamers.club'
        }
    },
    ui: {
        mobileMenu: {
            mobileMenuStyle: 'alternative4',
            showTurboBets: false,
            showJackpot: false,
            showRewardsAndPromo: false,
            showChat: false,
            showSports: true,
            showSupport: true,
            showCasino: false,
            showSlots: true,
            showLiveCasino: true,
            itemOrder: ['menu', 'support', 'slots', 'live-casino', 'sports']
        },
        accordion: {
            accordionStyle: 'momentum',
            useRemoteIcons: true
        },
        auth: {
            useSolidAccentOAuthButton: false,
            showWalletConnect: false,
            useTightModalBodyPadding: false,
            useOffsetModalCloseButton: false,
            hideReferalCode: true,
            passwordCredentials: {
                minPasswordLength: 7,
                useInlineLoading: true
            }
        },
        background: {
            backgroundStyle: 'solid'
        },
        bannerSwiper: {
            bannerSwiperStyle: 'alternative'
        },
        cardSwiper: {
            cardSwiperStyle: 'alternative4',
            viewAllAsButton: false,
            showNavigationArrows: true,
            disableEdgeMask: false,
            useRemoteIcons: true
        },
        card: {
            isOverlayBlur: true
        },
        button: {
            buttonStyle: 'solid-static',
            useUppercaseAsDefault: true,
            usebuttonBackgroundImage: false
        },
        betby: {
            betslipBottom: 20,
            customUI: true
        },
        betfeed: {
            betfeedStyle: 'momentum',
            usedVerbiage: 'live',
            rowDensity: 'compact'
        },
        cashier: {
            useAcceptDeclineBonusType: true,
            withdrawOnlyUsdt: true,
            withdrawOnlyUsdtMemeCoins: true,
            showConversionRateDeposit: true,
            showWiddrawalOnlyUSDT: false,
            showProgressBarBonusMoney: true,
            useBuyCryptoIFrame: false,
            buyCryptoMaxAmount: 5000,
            buyCryptoMinAmount: 15,
            showQrCodeBuyCrypto: false,
            useSearchInputOnCryptoDropdown: false,
            showImageOnDepositBonusOffers: true,
            depositBonusWageringContributions: [
                { category: 'slots', percentage: 100 },
                { category: 'originals', percentage: 5 },
                { category: 'live_casino', percentage: 0 },
                { category: 'table_games', percentage: 0 }
            ],
            showWithdrawalWarningIfNoFunds: true,
            showWithdrawalPlayRequirementImmediately: true,
            cashierStyle: 'momentum',
            useCashierHomeScreen: true,
            useSidetabs: false,
            buyCryptoEnabled: false,
            useCashierV4: false,
            useCompactDepositAddressOptionLayout: false,
            extendCashierVerbiageKeysWithBrandLabel: true,
            useConfigBaseCurrency: true,
            useVerificationStep: true,
            onlyFiatCurrency: true,
            integerCashAmounts: true,
            showPaymentLogos: false
        },
        casinoLobby: {
            casinoLobbyStyle: 'momentum',
            showLiveWins: true,
            showOriginalsCategoryRail: true,
            showJackpotDrop: false
        },
        checkbox: {
            useAlternativeTick: false,
            checkboxStyle: 'alternative4'
        },
        dropdown: {
            dropdownStyle: 'alternative4',
            useDropdownBackgroundImage: false,
            applyBackgroundBlur: true
        },
        emailVerify: {
            emailVerifyStyle: 'alternative4'
        },
        footer: {
            footerStyle: 'alternative4',
            useEmbeddedShellDecor: false,
            useLegalsMarkdownContent: true,
            useLiveChat: true,
            showSports: true,
            hideFooterFaqLink: false,
            hideGambleAwareLink: true,
            dmca: {
                protectionId: 'bf2fe123-500f-4642-b581-30a4fe50e492'
            },
            contact: {
                supportEmail: 'destek@turboslot.com',
                financeEmail: 'finans@turboslot.com'
            }
        },
        faq: {
            layout: 'single'
        },
        games: {
            showRacesLeaderboard: false,
            showNavigationOnMobile: false,
            showLikeButton: true,
            showLogoWhenPlayingDesktop: false,
            showGameInfoModalOnGamePathMobile: false,
            applyPedestalIllustrationHueShift: true,
            useCompactRacesLeaderboardInfoBackdrop: true,
            showRacesLeaderboardPerimeterIllustrations: false,
            isGameModalOverlayBlur: true
        },
        header: {
            headerStyle: 'alternative4',
            buttonLoginVariant: 'secondary',
            useTightRewardsToggleHorizontalPadding: false,
            profileProgressStyle: 'border'
        },
        helpdesk: {
            useDynamicBonusTerms: true
        },
        home: {
            homeStyle: 'momentum',
            showBuyCryptoBanner: false,
            showLiveWins: true,
            cryptoBannerStyle: 'alternative',
            buyCryptoBannerArtStyle: 'minimal',
            showAdventCalendarPage: false,
            showJackpotDrop: false
        },
        icons: {
            vipHeaderGlyphDarkFill: false,
            statusIconsUseWarmPalette: false,
            expandSectionToggleUsesMintAccent: false,
            navIconPickerAllowRemoteAssets: true,
            navIconPickerUseBundledIconFactories: false
        },
        infoCard: {
            infoCardStyle: 'solid-dark',
            hideBackgroundImage: true
        },
        iframeModal: {
            useMarginTop: true
        },
        input: {
            inputStyle: 'alternative4',
            transparentBackground: true
        },
        layout: {
            layoutStyle: 'alternative4',
            isContrastTextColor: true,
            useCompactVerticalPagePadding: true,
            useReducedMarginsInHomePage: false,
            useCurrentColorSidebar: true,
            useReferralIconAnimated: false,
            useNewIcons: false,
            useRemoteIcons: true,
            showCryptoPriceDropdown: false,
            showNotInCatalogGames: false,
            showUpdownGameDropdown: false,
            useReferralBannerOnlyImageCustom: true,
            usePromoItemContentCustom: true,
            useCentralButtonOnMobileMenu: false,
            sectionIconSize: 24,
            useExpandedRankPresentation: false,
            useAlternateMobileSidebarBackdrop: false,
            embedWebSiteOrganizationJsonLd: false
        },
        liveWins: {
            liveWinsStyle: 'momentum',
            usedVerbiage: 'live_wins',
            useSpecialWinCards: false
        },
        loading: {
            useLottie: false,
            publicInitPageLoadDisplayFor: 3000,
            playerInitPageLoadDisplayFor: 3000,
            useCustomLoading: true
        },
        maintenance: {
            maintenanceStyle: 'default',
            contentSource: 'hardcoded',
            showFollowUs: false,
            contactSupportTone: 'accent'
        },
        geoblock: {
            contentSource: 'hardcoded'
        },
        modal: {
            modalStyle: 'flat',
            applyBackgroundBlur: true,
            hideBanners: true
        },
        walletDropdown: {
            applyBackgroundBlur: true,
            showBalancePreferenceToggles: true
        },
        notifications: {
            notificationsStyle: 'alternative4',
            useBorderedPlayerNotificationsIcon: true,
            useGradientPublicNotificationsIcon: true,
            useExtendedDepositNotificationTitles: false,
            useTransparentTabs: true
        },
        updates: {
            silentAutoUpdate: true
        },
        toasts: {
            toastsStyle: 'momentum',
            isLocalIcon: false
        },
        profileModal: {
            profileModalStyle: 'alternative5',
            showFavouriteSection: true,
            showFavouriteToken: false,
            useStarsBackgroundOnFavouriteToken: false,
            useTokenArtBackgroundOnDesktop: true,
            useCompactFavouriteTokenMobileCard: true,
            hideOtherPlayerProfile: true,
            maskUsernames: true
        },
        promotions: {
            showExpiredPromotions: false,
            useAspectRatioBoxDetailCustom: true,
            useLiveJackpotTitle: true,
            promotionsStyle: 'momentum',
            promoCtasMatchLoggedInWhenLoggedOut: true
        },
        provider: {
            hideProvidersHeroTitle: true,
            providerStyle: 'alternative4',
            useSolidPrimaryGameCountBadge: true
        },
        referral: {
            referralDashboardBannerType: 'onlyImage',
            faqTitleStyle: 'badge',
            faqVisibilityPreset: 'all',
            accordionGlassStyle: false,
            rulesCardsStyle: 'illustrated',
            rulesFootnoteMuted: false,
            highlightStepTitles: false,
            rankProgressPalette: 'cool',
            usePrefixedVerbiageKeys: true,
            shareModalStyle: 'rich',
            shareMessageVariant: 'campaign',
            shareBannerStyle: 'classic',
            referralDashboardBannerStyle: 'classic'
        },
        transparency: {
            enabled: true
        },
        affiliates: {
            enabled: false,
            usePrefixedVerbiageKeys: true
        },
        rewardsDropdown: {
            rewardsDropdownStyle: 'momentum',
            useTransparentBackground: true,
            useComfortableRewardsTimerLabels: false,
            useCompactRewardsTimer: true,
            showSeasonalRewardsCampaignTabs: false,
            useInstantCashbackRequest: true,
            hidePendingAmountForInstantCashback: true
        },
        seoText: {
            style: 'momentum',
            enabled: false
        },
        settings: {
            settingsStyle: 'alternative'
        },
        sidebar: {
            sidebarStyle: 'alternative4',
            showJackpot: false,
            showJackpotMEGA: false,
            showLuckyDip: false,
            showBanner: false,
            showSports: true,
            dropDownToggleTransparent: true,
            useRemoteIcons: true
        },
        table: {
            tableStyle: 'alternative4'
        },
        tabs: {
            tabsStyle: 'alternative4',
            useCompactTabStripRadius: true,
            tabButtonsDefaultVariant: 'accent',
            activeTabUsesDarkLabel: true
        },
        text: {
            successTextUsesWarmTone: false
        },
        toggle: {
            toggleStyle: 'alternative'
        },
        tooltip: {
            tooltipStyle: 'alternative'
        },
        topSection: {
            casinoTopSectionStyle: 'alternative'
        },
        transactions: {
            transactionsStyle: 'alternative',
            useSegmentedTabs: false,
            useElevatedRows: true,
            showEmptyStateIllustration: false,
            useTransparentTabs: true
        },
        vip: {
            vipDashboardStyle: 'alternative4',
            vipAboutStyle: 'momentum',
            vipAboutStylePreview: 'momentum',
            vipRankStyle: 'alternative',
            useMarkdownFaqs: true,
            heroCardOpacity: 0.9,
            rewardsTableLayout: 'summary2',
            rewardsTableKeyPrefix: 'turbo',
            rewardsProgressPalette: 'warm',
            includeWageringRequirementRow: true,
            reorderPrimaryBenefitCards: true,
            testimonialsHeaderStyle: 'headline',
            useCompactTestimonialsCardHeight: true,
            faqListLength: 'short',
            usePrefixedVerbiageKeys: true,
            assetSet: 'elevated',
            negativeBadgeTone: 'rose',
            showRankPrefixBeforeDisplayName: false,
            useAccentPendingTotalsBadge: true,
            useBorderOnMiniVipCalendarCard: true,
            useCompactClubOverviewSectionHeights: true,
            useCompactRoyaltyBannerTypography: true,
            useExpandedRoyaltyBannerSectionSpacing: true,
            useGradientVipCalendarDateHeader: false,
            useTallerRoyaltyBannerOnNarrowScreens: true,
            showRoyaltyBannerInDashboard: false,
            calendarSummaryLabel: 'claimed',
            includeRaceInRakebackBreakdown: false,
            showVipRewardTooltips: false,
            monthlyRewardsTooltipStyle: 'compact',
            useClassicVipCalendarCardChrome: false,
            useMomentumVipCalendarCard: true,
            rakeboostProgressTone: 'accent',
            hiddenRewardTypes: ['CASHBACK_DAILY', 'RAKEBOOST'],
            instantCashbackCardStyle: 'request',
            compactTotalsStrip: true,
            useTurboRewardNames: true,
            fixedRewardsGrid: true,
            useInstantCashbackLabel: true,
            useVipLevelsTranslation: true
        },
        progressBar: {
            showProgressIcon: false
        },
        profileDropdown: {
            showSupport: false,
            profileDropdownStyle: 'alternative2',
            useAlternateProfileMenuChrome: true
        }
    }
};
const themeSettings = [
    {
        ...themeSetting,
        brand: 'turbo-gamma.previewenv.net',
        noIndex: true
    },
    {
        ...themeSetting,
        brand: 'prod-turbo.previewenv.net',
        noIndex: true
    },
    {
        ...themeSetting,
        brand: 'tsdomain1.online',
        noIndex: true
    },
    {
        ...themeSetting,
        brand: 'localhost',
        noIndex: true
    }
];
export const getThemeSetting = (domain, fullDomain) => {
    const setting = themeSettings.find((s) => fullDomain.includes(s.brand));
    if (setting)
        return setting;
    return themeSetting;
};
export const endpointSettings = [
    {
        name: 'turbo',
        theme: Theme.Turboslots,
        base: 'monopoly-turbo.prod.infinitro.dev',
        baseCurrency: 'TRY',
        baseCurrencySymbol: '₺',
        baseCurrencyDigits: 2,
        realm: 'prod-turbo',
        catalogFilter: CatalogFilter.ReleaseGames,
        endpointType: EndpointType.Production,
        reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff',
        optimoveTenantId: '1946',
        optimoveTenantToken: 'e85e6a8fceb740349579828c26e0917e',
        gamityBrandRef: 'turbobet',
        gamityCurrency: 'TRY',
        integrationRef: 'visionlink-gametech-as',
        gamityEnvironment: 'production',
        // TODO: replace with the real tenant ref issued for this brand.
        sportmodity: {
            enabled: true,
            tenantRef: 'YOUR_TENANT',
            sdkBaseUrl: 'https://betting-dev.sportsmodity.com',
            embedUrl: '/embed'
        }
    }
];
export const endpointSetting = (appMode, // eslint-disable-line @typescript-eslint/no-unused-vars
domain, // eslint-disable-line @typescript-eslint/no-unused-vars
fullDomain // eslint-disable-line @typescript-eslint/no-unused-vars
) => {
    return endpointSettings[0];
};
